import {SmartComponent} from "smart-component-js";


class AccordionComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.yxpAccordionBlock = this.element.querySelector(".yxpAccordionBlock");
        this.yxpAccordionContainer = this.element.querySelector(".yxpAccordionContainer");
        this.init();
        console.log("ACORDION MODULE");
    }

    removeYxpAccordionBlockActive() {
        this.yxpAccordionBlock.classList.remove('yxpAccordionActive');
        this.yxpAccordionContainer.classList.remove('yxpAccordionActive');
    }

    init() {
        this.removeYxpAccordionBlockActive();
    }

}

export default AccordionComponent;
